<app-loader></app-loader>

<!-- ==================== DESKTOP LAYOUT ==================== -->
<div class="wallet-page">
  <div class="page-title-section">
    <h1
      class="page-title text-2xl md:text-3xl font-black text-white tracking-tight uppercase italic"
    >
      WALLET <span class="title-italic">CENTRAL</span>
    </h1>
    <p class="page-subtitle">FUNDS · DEPOSITS · WITHDRAWALS · HISTORY</p>
  </div>

  <!-- Wallet Card -->
  <div class="wallet-cards">
    <div class="wallet-card card-main">
      <div class="card-top-row">
        <div class="card-label">
          <span class="label-dot dot-green"></span>
          <span class="label-text">WALLET</span>
        </div>
        <span class="badge badge-green">ACTIVE</span>
      </div>
      <div class="card-balance">
        <span class="balance-value"
          >${{ showBalance ? integerBalance : "0.00" }}</span
        >
      </div>
      <p class="card-sublabel">AVAILABLE BALANCE</p>
      <div class="card-buttons">
        <button class="btn-deposit" (click)="openAddBalanceModal()">
          <span class="btn-icon">+</span> DEPOSIT
        </button>
        <button class="btn-withdraw" (click)="openWithdrawBalanceModal()">
          <span class="btn-icon"
            ><svg
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <line x1="7" y1="17" x2="17" y2="7"></line>
              <polyline points="7 7 17 7 17 17"></polyline></svg
          ></span>
          WITHDRAW
        </button>
      </div>
    </div>
  </div>

  <!-- Transactions Panel -->
  <div class="transactions-panel">
    <div class="tab-bar">
      <button
        class="tab-btn tab-selected"
        [class.tab-selected]="selectedTab === 'current'"
        (click)="selectedTab = 'current'"
      >
        CURRENT WALLET
      </button>

      <div class="tab-filters">
        <div class="dropdown-wrap">
          <button
            class="dropdown-trigger"
            [class.active]="dropdownOpen"
            (click)="dropdownOpen = !dropdownOpen"
          >
            <span>{{ selectedFilter }}</span>
            <span class="caret">▼</span>
          </button>
          <ul class="dropdown-list" *ngIf="dropdownOpen">
            <li (click)="selectFilter('All', $event)">All</li>
            <li (click)="selectFilter('Credited', $event)">Credited</li>
            <li (click)="selectFilter('Debited', $event)">Debited</li>
          </ul>
        </div>
        <div class="search-wrap">
          <i class="fas fa-search search-icon"></i>
          <input
            type="text"
            class="search-input"
            placeholder="Search transactions..."
            [(ngModel)]="searchControl"
            (keyup.enter)="performSearch()"
          />
        </div>
        <div class="date-filters">
          <div class="date-field">
            <span class="date-label">From</span>
            <input
              type="date"
              class="date-input"
              [(ngModel)]="startDate"
              (change)="onStartDateChange(startDate)"
            />
          </div>
          <div class="date-field">
            <span class="date-label">To</span>
            <input
              type="date"
              class="date-input"
              [(ngModel)]="endDate"
              (change)="performSearch()"
            />
          </div>
        </div>
        <button
          class="btn-reset"
          (click)="resetFilters()"
          title="Reset filters"
        >
          <i class="fas fa-rotate-right"></i>
        </button>
      </div>
    </div>

    <!-- ✅ UPDATED: 7-column header -->
    <div class="table-head">
      <div class="col col-sr">SR</div>
      <div class="col col-type">TYPE</div>
      <div class="col col-amount">AMOUNT</div>
      <div class="col col-bonus">BONUS</div>
      <div class="col col-status">STATUS</div>
      <div class="col col-order-id">TRANSACTION ID</div>
      <div class="col col-date">DATE & TIME</div>
    </div>

    <div
      #transactionTable
      (scroll)="onScroll()"
      class="table-body"
      *ngIf="filteredTransactions.length > 0; else noRecord"
    >
      <!-- ✅ UPDATED: row columns match header order exactly -->
      <div
        *ngFor="let transaction of filteredTransactions; let i = index"
        class="table-row"
      >
        <!-- Sr -->
        <div class="col col-sr">
          <span class="value">{{ i + 1 }}</span>
        </div>

        <!-- Type -->
        <!-- Type -->
        <div class="col col-type">
          <span class="type-label">
            {{ transaction.type | titlecase }} by {{ transaction.source }}
          </span>
        </div>

        <!-- Amount -->
        <div class="col col-amount">
          <span
            class="amt"
            [class.amt-green]="transaction.type === 'credit'"
            [class.amt-red]="transaction.type === 'debit'"
          >
            {{
              transaction.type === "credit"
                ? "+"
                : transaction.type === "debit"
                  ? "-"
                  : ""
            }}${{ transaction.balance.toLocaleString() }}
          </span>
          <span
            class="amt-paid"
            *ngIf="
              transaction.type === 'debit' && transaction.netPaidAmount > 0
            "
            >(${{ transaction.netPaidAmount }} paid)</span
          >
        </div>

        <!-- Bonus -->
        <div class="col col-bonus">
          <span class="value">
            {{ +transaction.bonus > 0 ? "$" + transaction.bonus : "//" }}
          </span>
        </div>

        <!-- Status -->
        <div class="col col-status">
          <span
            class="status-tag"
            [class.sts-pending]="transaction.status === 'Pending'"
            [class.sts-approved]="transaction.status === 'Approved'"
            [class.sts-decline]="transaction.status === 'Decline'"
          >
            <span class="sts-dot"></span> {{ transaction.status | uppercase }}
          </span>
          <button
            *ngIf="
              transaction.type === 'debit' &&
              transaction.source?.toLowerCase() === 'withdraw' &&
              transaction.status === 'Pending'
            "
            (click)="openRejectionModal(transaction)"
            class="btn-cancel-row"
          >
            <i class="fa-solid fa-circle-xmark"></i> CANCEL
          </button>
          <span class="relative" *ngIf="transaction.status === 'Decline'">
            <fa-icon [icon]="infoIcon" class="hover-icon"></fa-icon>
            <div class="tooltip">Reason: {{ transaction?.comment }}</div>
          </span>
        </div>

        <!-- Transaction Id -->
        <div class="col col-order-id">
          <span class="value text-gray-400 font-mono">{{
            transaction.orderID
          }}</span>
        </div>

        <!-- Date & Time -->
        <div class="col col-date">
          <span class="date-main">{{ transaction.time | localTime }}</span>
        </div>
      </div>

      <div id="sentinel"></div>
    </div>

    <ng-template #noRecord>
      <div class="empty-state">
        <p>No records found.</p>
      </div>
    </ng-template>

    <div class="pagination-bar">
      <span class="pagination-info"
        >SHOWING {{ filteredTransactions.length }} - PAGE {{ currentPage }} OF
        1</span
      >
      <button
        class="pagination-next"
        (click)="currentPage = currentPage + 1"
        [disabled]="filteredTransactions.length < 10"
      >
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <polyline points="9 18 15 12 9 6"></polyline>
        </svg>
      </button>
    </div>
  </div>

  <!-- Charts Row -->
  <div class="charts-row">
    <div class="chart-card">
      <div class="chart-head">
        <div class="chart-label">
          <span class="chart-icon-box bar-box"></span>
          <span class="chart-name">DEPOSIT HISTORY</span>
        </div>
        <span class="chart-range">LAST 30 DAYS</span>
      </div>
      <div class="chart-body">
        <div class="y-axis">
          <span>$20</span><span>$15</span><span>$10</span><span>$5</span
          ><span>$0</span>
        </div>
        <div class="bar-chart">
          <div class="bar" style="height: 12%"></div>
          <div class="bar" style="height: 8%"></div>
          <div class="bar" style="height: 5%"></div>
          <div class="bar" style="height: 3%"></div>
          <div class="bar" style="height: 2%"></div>
          <div class="bar" style="height: 1%"></div>
          <div class="bar" style="height: 1%"></div>
          <div class="bar bar-gold" style="height: 55%"></div>
          <div class="bar" style="height: 1%"></div>
          <div class="bar" style="height: 2%"></div>
          <div class="bar" style="height: 1%"></div>
          <div class="bar" style="height: 1%"></div>
          <div class="bar" style="height: 1%"></div>
          <div class="bar" style="height: 1%"></div>
        </div>
      </div>
    </div>

    <div class="chart-card">
      <div class="chart-head">
        <div class="chart-label">
          <span class="chart-icon-box line-box"></span>
          <span class="chart-name">BALANCE TREND</span>
        </div>
        <span class="chart-range">LAST 30 DAYS</span>
      </div>
      <div class="chart-body chart-body-wide">
        <svg viewBox="0 0 500 120" preserveAspectRatio="none" class="trend-svg">
          <defs>
            <linearGradient id="areaGrad" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stop-color="#10b981" stop-opacity="0.35" />
              <stop offset="100%" stop-color="#10b981" stop-opacity="0.02" />
            </linearGradient>
          </defs>
          <path
            d="M0,100 L20,98 L50,96 L80,95 L110,93 L140,91 L170,88 L200,84 L230,78 L260,70 L290,60 L320,48 L350,35 L380,22 L410,14 L440,10 L470,8 L500,6 L500,120 L0,120 Z"
            fill="url(#areaGrad)"
          />
          <path
            d="M0,100 L20,98 L50,96 L80,95 L110,93 L140,91 L170,88 L200,84 L230,78 L260,70 L290,60 L320,48 L350,35 L380,22 L410,14 L440,10 L470,8 L500,6"
            fill="none"
            stroke="#10b981"
            stroke-width="2"
          />
        </svg>
      </div>
    </div>
  </div>
</div>

<!-- ==================== MOBILE LAYOUT ==================== -->
<div class="wallet-page mobile-only">
  <div class="page-title-section">
    <h1 class="page-title">WALLET <span class="title-italic">CENTRAL</span></h1>
    <p class="page-subtitle">FUNDS · DEPOSITS · WITHDRAWALS · HISTORY</p>
  </div>

  <div class="wallet-cards wallet-cards-mobile">
    <div class="wallet-card card-main">
      <div class="card-top-row">
        <div class="card-label">
          <span class="label-dot dot-green"></span>
          <span class="label-text">WALLET</span>
        </div>
        <span class="badge badge-green">ACTIVE</span>
      </div>
      <div class="card-balance">
        <span class="balance-value"
          >${{ showBalance ? integerBalance : "0.00" }}</span
        >
      </div>
      <p class="card-sublabel">AVAILABLE BALANCE</p>
      <div class="card-buttons">
        <button class="btn-deposit" (click)="openAddBalanceModal()">
          <span class="btn-icon">+</span> DEPOSIT
        </button>
        <button class="btn-withdraw" (click)="openWithdrawBalanceModal()">
          <span class="btn-icon"
            ><svg
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <line x1="7" y1="17" x2="17" y2="7"></line>
              <polyline points="7 7 17 7 17 17"></polyline></svg
          ></span>
          WITHDRAW
        </button>
      </div>
    </div>
  </div>

  <div class="transactions-panel">
    <div class="tab-bar">
      <button
        class="tab-btn tab-selected"
        [class.tab-selected]="selectedTab === 'current'"
        (click)="selectedTab = 'current'"
      >
        CURRENT WALLET
      </button>

      <div class="tab-filters">
        <div class="search-wrap">
          <i class="fas fa-search search-icon"></i>
          <input
            type="text"
            class="search-input"
            placeholder="Search..."
            [(ngModel)]="searchControl"
            (keyup.enter)="performSearch()"
          />
        </div>
        <div class="flex flex-row">
          <div class="date-filters">
            <div class="date-field">
              <span class="date-label">From</span>
              <input
                type="date"
                class="date-input"
                [(ngModel)]="startDate"
                (change)="onStartDateChange(startDate)"
              />
            </div>
            <div class="date-field">
              <span class="date-label">To</span>
              <input
                type="date"
                class="date-input"
                [(ngModel)]="endDate"
                (change)="performSearch()"
              />
            </div>
          </div>
          <button
            class="btn-reset"
            (click)="resetFilters()"
            title="Reset filters"
          >
            <i class="fas fa-rotate-right"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="filter-bar">
      <div class="filter-left">
        <div class="dropdown-wrap">
          <button
            class="dropdown-trigger"
            [class.active]="dropdownOpen"
            (click)="dropdownOpen = !dropdownOpen"
          >
            <span>{{ selectedFilter }}</span
            ><span class="caret">▼</span>
          </button>
          <ul class="dropdown-list" *ngIf="dropdownOpen">
            <li (click)="selectFilter('All', $event)">All</li>
            <li (click)="selectFilter('Credited', $event)">Credited</li>
            <li (click)="selectFilter('Debited', $event)">Debited</li>
          </ul>
        </div>
      </div>
      <div class="filter-right">
        <button class="btn-limit">LIMIT</button>
      </div>
    </div>
    <div
      class="mobile-tx-list"
      (scroll)="onMobileScroll($event)"
      *ngIf="filteredTransactions.length > 0; else noRecordMobile"
    >
      <div
        *ngFor="let tx of filteredTransactions; let i = index"
        class="mobile-tx-item"
      >
        <div class="mobile-tx-left">
          <span class="type-index">{{ i + 1 }}</span>
          <div class="mobile-tx-info">
            <span class="mobile-tx-method">{{
              tx.type === "credit" ? "CRYPTOCURRENCY" : (tx.source | uppercase)
            }}</span>
            <span class="mobile-tx-time">{{ tx.time | localTime }}</span>
          </div>
        </div>
        <div class="mobile-tx-right">
          <span
            class="amt"
            [class.amt-green]="tx.type === 'credit'"
            [class.amt-red]="tx.type === 'debit'"
          >
            {{ tx.type === "credit" ? "+" : "-" }}${{
              tx.balance.toLocaleString()
            }}
          </span>
          <span class="status-tag sts-pending" *ngIf="tx.status === 'Pending'"
            ><span class="sts-dot"></span> {{ tx.status | uppercase }}</span
          >
        </div>
      </div>
    </div>
    <ng-template #noRecordMobile>
      <div class="empty-state">
        <p>No records found.</p>
      </div>
    </ng-template>
    <div class="pagination-bar">
      <span class="pagination-info"
        >SHOWING {{ filteredTransactions.length }} - PAGE {{ currentPage }} OF
        1</span
      >
      <button
        class="pagination-next"
        (click)="currentPage = currentPage + 1"
        [disabled]="filteredTransactions.length < 10"
      >
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <polyline points="9 18 15 12 9 6"></polyline>
        </svg>
      </button>
    </div>
  </div>
</div>

<!-- ==================== ADD BALANCE MODAL ==================== -->
<div *ngIf="showModal" class="modal-overlay" (click)="hideWalletModal()">
  <div class="modal-box modal slide-up" (click)="$event.stopPropagation()">
    <div class="modal-head">
      <h2 class="modal-heading">Add Balance</h2>
      <button class="modal-x" (click)="hideWalletModal()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>
    <div class="modal-content">
      <div class="modal-banner">
        <img
          src="https://cmax-2.pages.dev/assets/payments/walletbanner1.png"
          alt="Banner"
          class="banner-img"
        />
      </div>
      <div class="modal-balance-line">
        Total Balance: <span class="gold">${{ integerBalance }}</span>
      </div>
      <div class="pay-methods-row">
        @for (account of withdrawPaymentMethods; track account.id) {
          <div
            class="pay-tile"
            [class.pay-selected]="selectedAccountType === account.name"
            (click)="togglePayment(account.name, account.isActive, $event)"
          >
            <img
              [src]="account.bg_image"
              [alt]="account.name"
              class="pay-tile-icon"
            />
            <span class="pay-tile-name">{{ account.name }}</span>
            <div
              *ngIf="account.name !== 'Card' && account.name !== 'CashApp'"
              class="soon-overlay"
            >
              <span>Coming Soon</span>
            </div>
          </div>
        }
      </div>
      <form
        [formGroup]="paymentForm"
        (ngSubmit)="pay()"
        *ngIf="showcard"
        class="pay-form"
      >
        <input
          type="number"
          formControlName="cardNumber"
          placeholder="Card Number"
          class="modal-input"
        />
        <div
          *ngIf="
            paymentForm.get('cardNumber')?.invalid &&
            paymentForm.get('cardNumber')?.touched
          "
          class="field-err"
        >
          Card number is required (13-16 digits).
        </div>
        <div class="input-row">
          <div class="input-half">
            <input
              type="number"
              formControlName="month"
              placeholder="MM"
              class="modal-input"
            />
            <div
              *ngIf="
                paymentForm.get('month')?.invalid &&
                paymentForm.get('month')?.touched
              "
              class="field-err"
            >
              Valid month (01-12) is required.
            </div>
          </div>
          <div class="input-half">
            <input
              type="number"
              formControlName="year"
              placeholder="YYYY"
              class="modal-input"
            />
            <div
              *ngIf="
                paymentForm.get('year')?.invalid &&
                paymentForm.get('year')?.touched
              "
              class="field-err"
            >
              Valid 4-digit year is required.
            </div>
          </div>
        </div>
        <input
          type="number"
          formControlName="cvv"
          placeholder="CVV"
          class="modal-input"
        />
        <div
          *ngIf="
            paymentForm.get('cvv')?.invalid && paymentForm.get('cvv')?.touched
          "
          class="field-err"
        >
          CVV is required (3 or 4 digits).
        </div>
        <input
          type="number"
          formControlName="amount"
          placeholder="Amount"
          class="modal-input"
        />
        <div
          *ngIf="
            paymentForm.get('amount')?.invalid &&
            paymentForm.get('amount')?.touched
          "
          class="field-err"
        >
          Amount is required (min $1).
        </div>
        <div class="modal-btns">
          <button
            type="button"
            (click)="hideWalletModal()"
            class="btn-m-cancel"
          >
            Close
          </button>
          <button type="submit" class="btn-m-submit">
            Pay ${{ paymentForm.get("amount")?.value || "..." }} Now
          </button>
        </div>
      </form>
      <form
        [formGroup]="cashappForm"
        (ngSubmit)="paycashApp()"
        *ngIf="showcashApp"
        class="pay-form"
      >
        <input
          type="number"
          formControlName="amount"
          placeholder="Amount"
          class="modal-input"
        />
        <div
          *ngIf="
            cashappForm.get('amount')?.invalid &&
            cashappForm.get('amount')?.touched
          "
          class="field-err"
        >
          Amount is required (min $1).
        </div>
        <div class="modal-btns">
          <button
            type="button"
            (click)="hideWalletModal()"
            class="btn-m-cancel"
          >
            Close
          </button>
          <button type="submit" class="btn-m-submit">
            Pay ${{ cashappForm.get("amount")?.value || "..." }} Now
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- ==================== WITHDRAW MODAL ==================== -->
<div
  *ngIf="showwithdrawModal"
  class="modal-overlay"
  (click)="hideWithdrawModal()"
>
  <div class="withdraw-modal-box" (click)="$event.stopPropagation()">
    <!-- METHOD SELECTION -->
    <div *ngIf="withdrawStep === 'methods'" class="withdraw-step">
      <div class="withdraw-head">
        <div class="withdraw-head-left">
          <button class="withdraw-back" (click)="hideWithdrawModal()">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M19 12H5"></path>
              <path d="M12 19l-7-7 7-7"></path>
            </svg>
          </button>
          <div class="withdraw-title-wrap">
            <h2 class="withdraw-title">Withdraw</h2>
            <div class="withdraw-balance-line">
              <span
                >BALANCE: <strong>${{ integerBalance }}</strong></span
              >
              <span class="withdraw-limit"
                >LIMIT: <strong>${{ withdrawLimit }}</strong></span
              >
            </div>
          </div>
        </div>
        <button class="withdraw-close" (click)="hideWithdrawModal()">
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
      <div class="withdraw-body">
        <div class="withdraw-info-box">
          <span class="withdraw-info-icon">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="12" cy="12" r="10"></circle>
              <polyline points="12 6 12 12 16 14"></polyline>
            </svg>
          </span>
          <div>
            <div class="withdraw-info-title">
              Manual Review • Min ${{ minWithdraw }}
            </div>
            <div class="withdraw-info-text">
              All withdrawals are reviewed and processed within 2 hours
            </div>
          </div>
        </div>

        <div class="withdraw-section-label">SELECT WITHDRAWAL METHOD</div>
        <div class="withdraw-method-list">
          @for (method of withdrawPaymentMethods; track method.id) {
            @if (method.isActive) {
              <div
                class="withdraw-method-item"
                [class.wm-active]="selectedAccountType === method.name"
                (click)="selectWithdrawMethod(method)"
              >
                <div class="withdraw-method-icon">
                  <img [src]="method.bg_image" [alt]="method.name" />
                </div>
                <div class="withdraw-method-meta">
                  <div class="withdraw-method-name">{{ method.name }}</div>
                  <div class="withdraw-method-sub">
                    Withdraw to your {{ method.name }}
                  </div>
                </div>
                <fa-icon
                  [icon]="faChevronRight"
                  class="withdraw-method-chevron"
                ></fa-icon>
              </div>
            }
          }
        </div>

        <div class="withdraw-foot-box">
          <div class="withdraw-foot-row">
            Minimum withdrawal: <strong>${{ minWithdraw }}.00</strong>
          </div>
          <div class="withdraw-foot-row">Processed within 2 hours</div>
          <div class="withdraw-foot-row withdraw-foot-bullet">
            Withdrawals are final once processed
          </div>
        </div>
      </div>
    </div>

    <!-- WITHDRAW FORM -->
    <div *ngIf="withdrawStep === 'form'" class="withdraw-step">
      <div class="withdraw-head">
        <div class="withdraw-head-left">
          <button class="withdraw-back" (click)="backToWithdrawMethods()">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M19 12H5"></path>
              <path d="M12 19l-7-7 7-7"></path>
            </svg>
          </button>
          <div class="withdraw-title-wrap">
            <h2 class="withdraw-title">
              Withdraw via {{ selectedWithdrawMethod?.name }}
            </h2>
            <div class="withdraw-balance-line">
              <span
                >BALANCE: <strong>${{ integerBalance }}</strong></span
              >
              <span class="withdraw-limit"
                >LIMIT: <strong>${{ withdrawLimit }}</strong></span
              >
            </div>
          </div>
        </div>
        <button class="withdraw-close" (click)="hideWithdrawModal()">
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
      <div class="withdraw-body">
        <div class="withdraw-field">
          <label class="withdraw-label"
            >AMOUNT (USD) <span class="withdraw-required">*</span></label
          >
          <div class="withdraw-amount-input">
            <span class="amount-dollar">$</span>
            <input
              type="number"
              [(ngModel)]="amouttowithdraw"
              (input)="removeZero($event)"
              placeholder="0"
            />
          </div>
          <div class="withdraw-max">Max allowed: ${{ withdrawLimit }}</div>
        </div>

        <div class="withdraw-quick-amounts">
          <button
            *ngFor="let amt of quickWithdrawAmounts"
            type="button"
            (click)="setWithdrawAmount(amt)"
            [class.active]="amouttowithdraw == amt"
          >
            ${{ amt }}
          </button>
        </div>

        <div class="withdraw-field">
          <label class="withdraw-label">
            {{
              selectedWithdrawMethod?.name === "Paypal"
                ? "YOUR PAYPAL EMAIL"
                : "EMAIL / ACCOUNT TITLE"
            }}
          </label>
          <input
            type="text"
            [(ngModel)]="accountInfo"
            [placeholder]="
              selectedWithdrawMethod?.name === 'Paypal'
                ? 'yourname@email.com'
                : 'Enter account title'
            "
            class="withdraw-input"
          />
        </div>

        <div class="withdraw-field">
          <label class="withdraw-label">ACCOUNT NAME</label>
          <input
            type="text"
            [(ngModel)]="Customertag"
            placeholder="Full Name"
            class="withdraw-input"
          />
        </div>

        <div class="withdraw-field">
          <label class="withdraw-label"
            >QR CODE <span class="withdraw-optional">(optional)</span></label
          >
          <div class="withdraw-file-drop">
            <input
              id="withdraw-qr"
              type="file"
              (change)="onFileSelected($event)"
              class="hidden-input"
              accept="image/*"
            />
            <label for="withdraw-qr" class="withdraw-file-label">
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                <circle cx="8.5" cy="8.5" r="1.5"></circle>
                <polyline points="21 15 16 10 5 21"></polyline>
              </svg>
              <span>Attach a QR image of your account</span>
            </label>
            <div *ngIf="uploadProfileImage" class="withdraw-thumb">
              <img [src]="uploadProfileImage" alt="Preview" />
              <button type="button" (click)="clearSelection()">✕</button>
            </div>
          </div>
        </div>

        <div class="withdraw-notice">
          <span class="withdraw-notice-icon">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="12" cy="12" r="10"></circle>
              <polyline points="12 6 12 12 16 14"></polyline>
            </svg>
          </span>
          <span
            >Withdrawals are reviewed manually and processed within 2 hours.
            You'll be notified once complete.</span
          >
        </div>

        <button
          type="button"
          class="withdraw-submit"
          (click)="createWithdrawRequest()"
        >
          <fa-icon [icon]="faCheck"></fa-icon> SUBMIT WITHDRAWAL
        </button>
      </div>
    </div>
  </div>
</div>

<!-- ==================== REJECTION MODAL ==================== -->
<div
  *ngIf="showRejectionModal"
  class="modal-overlay"
  (click)="closeRejectionModal()"
>
  <div class="rejection-box modal slide-up" (click)="$event.stopPropagation()">
    <div class="rej-head">
      <h3 class="rej-title">
        <i class="fa-solid fa-circle-exclamation text-red-500"></i> Cancel
        Withdrawal
      </h3>
      <button class="modal-x" (click)="closeRejectionModal()">
        <i class="fa-solid fa-xmark text-xl"></i>
      </button>
    </div>
    <div class="rej-body">
      <p class="rej-desc">
        Are you sure you want to cancel this withdrawal request? Please provide
        a reason for the cancellation below.
      </p>
      <div class="form-group-m">
        <label class="form-lbl"
          >Cancellation Reason <span class="text-red-500">*</span></label
        ><textarea
          [(ngModel)]="rejectionReason"
          placeholder="e.g. Changed my mind, need to update details..."
          class="rej-textarea"
        ></textarea>
      </div>
    </div>
    <div class="rej-foot">
      <button (click)="closeRejectionModal()" class="rej-back">Go Back</button>
      <button
        (click)="confirmRejection()"
        [disabled]="!rejectionReason.trim()"
        class="rej-confirm"
      >
        Confirm Cancel
      </button>
    </div>
  </div>
</div>
